import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import "./index.css";
// import Header from "./components/Header.jsx";
import InfoLogin from "./components/InfoLogin.jsx";
import { Login, Logout } from "./components/Login.jsx";
import { LoadTest } from "./components/LoadTest.jsx";
import SignUp from "./components/SignUp.jsx";
import KonfirmasiData from "./components/KonfirmasiData.jsx";
import KonfirmasiToken from "./components/KonfirmasiToken.jsx";
import ProsesTest from "./components/ProsesTest.jsx";
import ProsesTestV2 from "./components/ProsesTestV2.jsx";
import ProsesTest2 from "./components/ProsesTest2.jsx";
import ProsesTest2V2 from "./components/ProsesTest2V2.jsx";
import { FinishTest } from "./components/FinishTest.jsx";
import RadioTes from "./components/RadioTest.jsx";
import ProsesTestKraeplin from "./components/ProsesTestKraeplin.jsx";
import Blocked from "./components/Blocked.jsx";
import AutoLogin from "./components/AutoLogin.jsx";

import ProsesTestReguler from "./components/ProsesTestReguler.jsx";
import ProsesTesOneFlow from "./components/ProsesTestOneFlow.jsx";

// Notifies the Android WebView of every React Router page transition.
// window.AndroidBridge is injected by the Android app; safe no-op in regular browsers.
function RouteChangeNotifier() {
  const location = useLocation();
  useEffect(() => {
    window.AndroidBridge?.notifyRouteChanged(location.pathname);
  }, [location.pathname]);
  return null;
}

function App() {
  useEffect(() => {
    // Prevent back navigation
    const handlePopState = () => {
      window.history.go(1);
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);
  return (
    <div>
      <BrowserRouter>
        <RouteChangeNotifier />
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/loadsoal_v1" element={<LoadTest />} />
          <Route path="/login" element={<Login />} />
          <Route path="/autologin" element={<AutoLogin />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/peserta/logout" element={<Logout />} />
          <Route path="/peserta/confirmdata" element={<KonfirmasiData />} />
          <Route path="/peserta/confirmtoken" element={<KonfirmasiToken />} />
          <Route path="/peserta/start_test" element={<ProsesTestReguler />} />
          <Route path="/peserta/start_test2" element={<ProsesTesOneFlow />} />
          <Route
            path="/peserta/start_test_kraeplin"
            element={<ProsesTestKraeplin />}
          />
          <Route path="/peserta/finish_test" element={<FinishTest />} />
          <Route path="/radiotest" element={<RadioTes />} />
          <Route path="/blocked" element={<Blocked />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
